<template>
  <div class="companies">
    <h1 v-bg-typography="'h1'">Companies</h1>
    <div class="search">
      <div>
        <bg-field
          class="search-input"
          label="Search"
          v-model="searchString"
          name="search"
        >
          <bg-input
            name="search"
            placeholder="Type in a company name"
            v-model="searchString"
          />
        </bg-field>
      </div>

      <bg-button
        variant="primary"
        text="Add company"
        @click="goTo('/admin/companies/new')"
        style="margin-bottom: 30px"
      />
    </div>

    <List
      ref="list"
      v-if="!$store.state.companies.loading"
      :headers="list.headers"
      :values="list.values"
      :actions="list.actions"
      :data="filteredItems"
      :fractions="list.fractions"
      :genderIcons="list.genderIcons"
      @change="getChanges"
      style="margin-bottom: 100px; max-width: 900px"
      :pagination="true"
    />

    <bg-loader :dark="true" v-if="$store.state.companies.loading"></bg-loader>
    <bg-modal
      v-if="isModalOpen"
      body="Are you sure you want to remove this company?"
      @close="isModalOpen = false"
    >
      <bg-button
        variant="secondary"
        text="Cancel"
        @click="isModalOpen = false"
      />
      <bg-button
        variant="destructive"
        class="action"
        text="Delete"
        @click="deleteCompany"
      />
    </bg-modal>
  </div>
</template>

<style scoped>
.search {
  display: flex;
  align-items: flex-end;
  gap: 20px;
}
</style>

<script>
import BgTypography from "@/directives/bg-typography";
import BgModal from "@/components/bg-modal";
import BgButton from "@/components/bg-button";
import BgLoader from "@/components/bg-loader";
import moment from "moment";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";
import BgSelect from "@/components/bg-select";

import List from "@/components/list";

import API from "@/api";
import { mapState } from "vuex";

export default {
  name: "companies",
  components: {
    BgModal,
    BgButton,
    BgLoader,
    List,
    BgField,
    BgInput,
    BgSelect,
  },
  directives: {
    BgTypography,
  },

  watch: {
    searchString: function() {
      const child = this.$refs.list;
      child.paginationReset();
    },
  },
  computed: {
    ...mapState({
      userState: (state) => state.user,
    }),
    filteredItems: function() {
      let items = this.$store.state.companies.companies;
      if (!Array.isArray(items)) return [];
      let input = this.searchString.toLowerCase();

      function compare(a, b) {
        // Use toUpperCase() to ignore character casing
        const brandA = a.name.toUpperCase();
        const brandB = b.name.toUpperCase();

        let comparison = 0;
        if (brandA > brandB) {
          comparison = 1;
        } else if (brandA < brandB) {
          comparison = -1;
        }
        return comparison;
      }
      items.sort(compare);

      items.forEach((com) => {
        if (com.contracts.length === 1) {
          com.end_date = moment(com.contracts[0].end_date).format("DD-MM-YYYY");
          com.available =
            com.contracts[0].available_tests.essential +
            com.contracts[0].available_tests.professional;
        } else if (com.contracts.length > 1) {
          let latest = null;
          for (let x in com.contracts) {
            if (
              !latest ||
              moment(com.contracts[x].end_date).isAfter(moment(latest.end_date))
            ) {
              latest = com.contracts[x];
            }
          }
          com.end_date = moment(latest.end_date).format("DD-MM-YYYY");
          com.available =
            latest.available_tests.essential +
            latest.available_tests.professional;
        }
      });

      function byName(company) {
        let companyName = company.name.toLowerCase();
        return companyName.includes(String(input));
      }
      if (this.searchString) {
        items = items.filter(byName);
      }

      return items;
    },
  },
  methods: {
    deleteCompany() {
      this.isModalOpen = false;
      this.isLoading = true;
      const res = API.user.deleteCompany(this.deleteCompanyId);
      setTimeout(async () => {
        await this.$store.dispatch("fetchAllCompanies");
      }, 1000);
      // this.isLoading = false;
    },

    getChanges(val) {
      if (val.action === "Select") {
        this.$router.replace(`/admin/companies/${val.item.id}`);
      } else if (val.action === "Delete") {
        this.deleteCompanyId = val.item.id;
        this.deleteCompanyAdminId = val.item.admin.id;
        this.isModalOpen = true;
      }
    },
    goTo(url) {
      this.$router.replace(url);
    },
  },
  data() {
    return {
      deleteCompanyId: null,
      deleteCompanyAdminId: null,
      deleteCompanyAdmin: {},
      isLoading: false,
      isModalOpen: false,
      items: [],
      list: {
        headers: ["Name", "Available tests", "End date"],
        values: ["name", "available", "end_date"],
        fractions: [3, 1, 1],
        actions: ["Delete"],
        genderIcons: false,
      },
      searchString: "",
    };
  },
};
</script>
